var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("database-management-modal", {
    ref: "modal",
    attrs: { element: _vm.region },
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function () {
          return [
            _c(
              "div",
              {
                class: _vm.hasErrorClass(
                  _vm.$v.region.admin_email,
                  "form-group"
                ),
              },
              [
                _c("label", { staticClass: "control-label" }, [
                  _vm._v("* Admin email"),
                ]),
                _c("br"),
                _vm._v(" "),
                _c("i", [
                  _vm._v(
                    "Add multiple email addresses in here to keep other stakeholders notified of any requests, separated by ','"
                  ),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.$v.region.admin_email.$model,
                      expression: "$v.region.admin_email.$model",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { name: "admin_email", type: "email" },
                  domProps: { value: _vm.$v.region.admin_email.$model },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.$v.region.admin_email,
                        "$model",
                        $event.target.value
                      )
                    },
                  },
                }),
                _vm._v(" "),
                _c("vuelidate-help", {
                  attrs: {
                    field: _vm.$v.region.admin_email,
                    label: "Admin email",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                class: _vm.hasErrorClass(
                  _vm.$v.region.from_email,
                  "form-group"
                ),
              },
              [
                _c("label", { staticClass: "control-label" }, [
                  _vm._v("* From email"),
                ]),
                _c("br"),
                _vm._v(" "),
                _c("i", [
                  _vm._v(
                    "From email address that will display to the recipient"
                  ),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.$v.region.from_email.$model,
                      expression: "$v.region.from_email.$model",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { name: "from_email", type: "email" },
                  domProps: { value: _vm.$v.region.from_email.$model },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.$v.region.from_email,
                        "$model",
                        $event.target.value
                      )
                    },
                  },
                }),
                _vm._v(" "),
                _c("vuelidate-help", {
                  attrs: {
                    field: _vm.$v.region.from_email,
                    label: "From email",
                  },
                }),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c(
              "ladda-button",
              {
                staticClass: "btn btn-lg btn-primary pull-right",
                attrs: {
                  click: _vm.saveRegion,
                  type: "button",
                  "data-dismiss": "modal",
                },
              },
              [_c("i", { staticClass: "fa fa-check" }), _vm._v(" Save")]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }